/**
 * Removes properties from an object.
 *
 * @see https://github.com/benjycui/omit.js
 *
 * @param obj object
 * @param fields properties to omit
 */
export const omitProps = <T, K extends keyof T> (obj:T, fields: Array<K>) =>  {
    const shallowCopy: T = {
        ...obj,
    };

    for (let i = 0; i < fields.length; i++) {
        const key = fields[i];
        delete shallowCopy[key];
    }
    return shallowCopy as Omit<T,K>;
}